import {http} from '@/helpers/http-helper';
import {headingLists} from '@/constants/search-constants';

class SearchField {
  constructor(
    field
  ) {
    this.field = field;
  }
}

class SearchFieldConditions {
  constructor(
    filter
  ) {
    this.filter = filter;
  }
}

class FieldList {
  constructor(
    uuid,
    createdAt,
    entity,
    filters,
    fields,
    campaign
  ) {
    this.uuid = uuid;
    this.createdAt = createdAt;
    this.entity = entity;
    this.filters = filters;
    this.fields = fields;
    this.campaign = campaign;
  }
}

export const searchFields = (value, type) => {
  return new Promise((resolve, reject) => {
    const url = '/fields';
    let params = null;
    if (type === 'single') {
      params = { entity: value}
    } else  {
      params = {entities: value }
    }
    http.get(url, params)
      .then((response) => {
        if (response.status === 200) {

          let fields = [];
          response.data.forEach((field) => {
            fields.push(
              new SearchField(
                field.field
              ));
            resolve({
              fields: fields,
              count: response.data.count
            });
          });
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const searchFieldConditions = (value) => {
  return new Promise((resolve, reject) => {
    const url = '/filters';
    http.get(url, {fieldType: value})
      .then((response) => {
        if (response.status === 200) {

          let filters = [];
          response.data.forEach((filter) => {
            filters.push(
              new SearchFieldConditions(
                filter.filter
              ));
            resolve({
              filters: filters,
              count: response.data.count
            });
          });
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getSearchFieldLists = (searchData) => {
  return new Promise((resolve, reject) => {
    const url = 'search';
    http.get(url, searchData)
      .then((response) => {
        if (response.status === 200) {
          let searchFieldLists = [];
          response.data.searchData.forEach((bankReturn) => {
            let innerData = JSON.parse(bankReturn.searchData);
            let fieldsData = JSON.parse(bankReturn.fields);
            let filters = [];
            let fields = [];
            innerData.forEach((item) => {
              item.rows.forEach((row) => {
                if (headingLists[row.field]) {
                  filters.push(headingLists[row.field]);
                } else {
                  filters.push(row.field);
                }
              })
            });
            fieldsData.forEach((item) =>{
              if (headingLists[item.field]) {
                fields.push(headingLists[item.field]);
              } else {
                fields.push(item.field);
              }
            });

            let entityString = '';
            switch (bankReturn.entity) {
              case 'SOCIO_NOSOCIO':
                entityString = 'Socio / No Socio';
                break;
              case 'CONSULTA':
                entityString = 'Consulta';
                break;
              case 'REMESA':
                entityString = 'Remesa';
                break;
              case 'RECIBO':
                entityString = 'Recibo';
                break;
              case 'DEVOLUCION':
                entityString = 'Devolución';
                break;
              default:
                entityString = bankReturn.entity;
                break;
            }

            searchFieldLists.push(
              new FieldList(
                bankReturn.uuid,
                new Date(bankReturn.createdAt),
                entityString,
                filters.toString(),
                fields.toString(),
                bankReturn.campaign.toString(),
              ));
          });

          resolve({
            searchFieldLists: searchFieldLists,
            count: response.data.count
          });
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getSearchListById = (searchId) => {
  return new Promise((resolve, reject) => {
    const url = '/search/' + searchId;
    http.get(url)
      .then((response) => {
        if (response.status === 200) {
          const searchData = response.data;
          resolve(searchData)
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
